export default "__VITE_ASSET__j21TBWVq__"